module.exports = __webpack_public_path__ + "img/s9.86745b8.png";